import type { BuildingGraph } from "building-types/building/buildingGraphTypes";
import type { Table } from "common/data/table";
import type { DatumAbstraction } from "./datumAbstractionTypes";
import { ensureDatumAbstractionUsageType } from "./datumAbstractionTypes";
import { DatumHorizontalUsageType } from "./datumUsageTypes";

/**
 * Resolves a wall-plane horizontal datum's U position from datum abstractions at consumption time.
 * The plane hash must exist on the building graph.
 */
export function resolveWallPlaneHorizontalDatumU(
  datumId: string,
  planeHash: string,
  datumAbstractions: Table<DatumAbstraction>,
  buildingGraph: Pick<BuildingGraph, "buildingPlanes">,
): number | undefined {
  if (!buildingGraph.buildingPlanes[planeHash]) {
    return undefined;
  }

  const abstraction = datumAbstractions[datumId];
  if (!abstraction?.isValidForUsage(DatumHorizontalUsageType.WALL_PLANE_HORIZONTAL)) {
    return undefined;
  }

  const wallPlaneAbstraction = ensureDatumAbstractionUsageType(
    DatumHorizontalUsageType.WALL_PLANE_HORIZONTAL,
    abstraction,
  );
  if (wallPlaneAbstraction.getPlaneHash() !== planeHash) {
    return undefined;
  }

  return wallPlaneAbstraction.resolveWallPlaneU();
}
